<app-menu></app-menu>
<mat-toolbar class="flexSpace" color="primary">Welcome to V3D Application, {{user.username}} </mat-toolbar>
<mat-card>
  <mat-card class="mat-elevation-z0 card-padding">
    <div>
      <p>You have access to the following areas:</p>
      <ul>
        <ng-container *ngFor="let area of areas()">
          <li>{{area}}</li>
        </ng-container>
      </ul>
    </div>
  </mat-card>
</mat-card>
